import { useEffect, useState } from "react";

const BASE_FEED = [
  { side: "BUY", sym: "XAUUSD", pips: 38.4, pnl: 412.7 },
  { side: "SELL", sym: "XAUUSD", pips: 22.1, pnl: 248.3 },
  { side: "BUY", sym: "XAUUSD", pips: 14.8, pnl: 167.5 },
  { side: "SELL", sym: "XAUUSD", pips: 44.2, pnl: 529.1 },
  { side: "BUY", sym: "XAUUSD", pips: 9.6, pnl: 104.2 },
  { side: "SELL", sym: "XAUUSD", pips: 31.7, pnl: 361.9 },
];

export default function LiveTicker() {
  const [feed, setFeed] = useState(BASE_FEED);
  useEffect(() => {
    const id = setInterval(() => {
      setFeed((prev) => prev.map((t, i) => ({ ...t, pnl: +(t.pnl + (Math.random() - 0.4) * 3).toFixed(2) })));
    }, 2200);
    return () => clearInterval(id);
  }, []);
  const row = [...feed, ...feed];
  return (
    <div data-testid="live-ticker" className="relative border-y border-[#23232a] bg-[#0a0a0b]/70">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 sm:py-2.5 flex items-center gap-3 sm:gap-4">
        <div className="flex items-center gap-2 shrink-0">
          <span className="w-2 h-2 rounded-full bg-[color:var(--green)] pulse-dot" />
          <span className="font-mono text-[10px] sm:text-[11px] uppercase tracking-[0.18em] text-[color:var(--green)]">LIVE</span>
        </div>
        <div className="mask-h overflow-hidden flex-1">
          <div className="ticker-track gap-6 sm:gap-8">
            {row.map((t, i) => (
              <div key={i} className="flex items-center gap-2 sm:gap-3 font-mono text-[11px] sm:text-xs text-[color:var(--ink-dim)]">
                <span className={`px-1.5 sm:px-2 py-0.5 rounded ${
                  t.side === "BUY" ? "bg-[rgba(0,255,136,.08)] text-[color:var(--green)]" : "bg-[rgba(231,180,59,.08)] text-[color:var(--gold)]"
                }`}>{t.side}</span>
                <span className="text-white">{t.sym}</span>
                <span>+{t.pips.toFixed(1)} pips</span>
                <span className="text-[color:var(--green)]">+${t.pnl.toFixed(2)}</span>
                <span className="text-[color:var(--ink-mute)]">•</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
